<template>
  <TableBody
    :items="items"
    :isInfinite="isInfinite"
    class="gw_table_small table-combos tblcombos"
    @mouseleave="handleComboMouseenter(null)"
  >
    <template #head_sticky>
      <TableHead
        :sortConf="tbl_sortConf"
        :thead="thead"
        class="gw_table_head_first-cell-sticky"
        @click:th="tbl_handleSort"
      >
        <template
          v-for="slotName in ['th_eq']"
          #[slotName]="v"
          :key="slotName"
        >
          <TableHeadCell
            :item="v.item"
            :sortConf="tbl_sortConf"
            @click="tbl_handleSort"
          >
            {{ v.item.name }}
            <div
              v-if="!showFlopContent"
              class="tblcombos_prefloponlytag text-nowrap"
              style="position: absolute; left: 0.25rem; top: 3rem; z-index: 9"
            >
              <div
                class="gw_btn clr-grey my-auto text-small text-center no-events"
                style="--padding: 0 2rem"
              >
                {{ $t('common.postflop_only') }}
              </div>
            </div>
          </TableHeadCell>
        </template>
        <template
          v-for="slotName in ['th_blocker_rate', 'th_unblocker_rate']"
          #[slotName]="v"
          :key="slotName"
        >
          <TableHeadCell
            :item="v.item"
            :sortConf="tbl_sortConf"
            @click="tbl_handleSort"
          >
            <div
              v-if="!mobile"
              class="csst"
              @mouseenter="e => fl_positionTooltip(e, { offset: -2, placement: 'bottom' })"
            >
              {{ v.item.name }}
              <div
                class="csst_content csst_content_hoverable text-smallest text-nowrap clr-primary"
                style="position: fixed"
                @click.stop="$store.dispatch('router_set_dialogs', 'blockers-tips-dialog')"
              >
                <i class="mdi mdi-information mr-1"></i
                ><span class="text-underline text-underline_hover"
                  >{{ $t('messages.more_about_blockers') }}
                </span>
              </div>
            </div>
            <div v-else>
              {{ v.item.name }}
            </div>

            <router-link
              v-if="slotName === 'th_blocker_rate' && !hasPremiumGameformat"
              style="position: absolute; left: 0.25rem; top: 3rem; z-index: 9; --padding: 0 2rem"
              class="gw_btn gw_btn_primary text-small weight_500 clr-white cursor-pointer"
              :to="{
                name: 'Subscription',
                query: { gm_type: gameformat.gm_type },
              }"
              data-tst="combos_table_hero_upgrade_btn"
            >
              <i class="mdi mdi-crown mr-1"></i>

              {{ solElite.want_use ? $t('common.elite') : $t('common.premium') }}
            </router-link>
          </TableHeadCell>
        </template>
      </TableHead>
    </template>

    <template #default="{ item, index }">
      <CombosTableRowHero
        :id="`${idPrefix || '0'}_${item.id}`"
        :thead="thead"
        :item="item"
        :index="index"
        :hasPremiumGameformat="hasPremiumGameformat"
        :useHex="useHex"
        :hasBlockers="hasBlockers"
        :showBetsIn="showBetsIn"
        :bettingInfo
        :showFlopContent="showFlopContent"
        :grouping="grouping"
        :isLocked="item.is_locked"
        @mouseenter="handleComboMouseenter(item)"
        @mousedown="handleComboMousedown(item)"
      >
      </CombosTableRowHero>
    </template>
  </TableBody>
</template>

<script>
import TableHead from '@/components/DataTables/v2/TableHead'
import TableHeadCell from '@/components/DataTables/v2/TableHeadCell'
import TableBody from '@/components/DataTables/v2/TableBody'
import CombosTableRowHero from '@/components/DataTables/v2/tables/CombosTable/CombosTableRowHero'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'
import { throttle } from 'lodash'

export default {
  name: 'CombosTableHero',
  components: {
    TableHead,
    TableHeadCell,
    TableBody,
    CombosTableRowHero,
  },
  mixins: [table_mix, float_mix, format_mix],
  props: {
    isInfinite: { type: Boolean, default: true },
    hasBlockers: { type: Boolean, default: true },
    tableGroups: { default: () => [] },
    lockedHandsIds: { default: () => [] },
    idPrefix: String,
    showAllCombos: Boolean,
    showFlopContent: Boolean,
    showGroupCombos: Boolean,
    heroGroup: Object,
    showBetsIn: String,
    bettingInfo: { type: Object, default: () => ({}) },
    grouping: String,
    useHex: Boolean,
    mobile: Boolean,
    tableMouseover: Boolean,
    hasPremiumGameformat: Boolean,
    solElite: Object,
    gameformat: Object,
    // initialSortConf: Object,
  },
  emits: ['combo:mousedown', 'combo:mouseenter'],
  data() {
    // this.hasPremiumGameformat = false
    this.tbl_persistSortKey = 'sort_combos_table_hero'
    this.l_sortConf = {
      sortKey: 'summary_idx',
      sortOrder: 'desc',
    }
    return {
      tbl_sortConf: this.l_sortConf,
    }
  },
  methods: {
    initSortConf() {
      this.tbl_sortConf = this.initialSortConf || this.l_sortConf
    },
    handleComboMousedown(item) {
      this.$emit('combo:mousedown', item)
    },
    handleComboMouseenter: throttle(function (hand) {
      this.$emit('combo:mouseenter', hand)
    }, 22),
    getSortedItems(items) {
      const res = items.map(i => i)
      const { sortKey, sortOrder } = this.tbl_sortConf
      const l_sortOrder = this.thead[sortKey].reverseSort
        ? sortOrder === 'desc'
          ? 'asc'
          : 'desc'
        : sortOrder

      const actionIdx = items[0]?.solution?.length - 1
      const aVal = l_sortOrder === 'desc' ? -1 : 1
      const bVal = l_sortOrder === 'desc' ? 1 : -1
      if (sortKey === 'summary_idx') {
        res.sort((a, b) => (a[sortKey] > b[sortKey] ? aVal : bVal))
      } else if (sortKey === 'strategy') {
        res.sort((a, b) =>
          a.solution[actionIdx].strategy > b.solution[actionIdx].strategy ? aVal : bVal,
        )
      } else {
        const heroIndex = 0
        res.sort((a, b) =>
          a.players[heroIndex][sortKey] > b.players[heroIndex][sortKey] ? aVal : bVal,
        )
      }
      return res
    },
  },
  computed: {
    allItems() {
      const heroIndex = 0
      let res = this.tableGroups.reduce(
        (a, b) => [...a, ...b.combos.filter(i => i.players[heroIndex].range)],
        [],
      )
      res = this.getSortedItems(res)
      return res
    },
    comboItems() {
      const heroIndex = 0
      const res = this.getSortedItems(
        (this.heroGroup?.combos || []).filter(i => i.players[heroIndex].range),
      )
      return res
    },
    items() {
      if (this.showAllCombos) {
        return this.allItems
      }
      if (this.showGroupCombos) {
        return this.comboItems
      }
      return this.tableMouseover ? this.comboItems : this.allItems
      // return this.allItems
    },
    thead() {
      const styles = {
        cssStyle: '--min-width-th: 5rem;--max-width-th: 5rem;',
        tdStyle: '--min-width-td: 5rem;--max-width-td: 5rem;',
      }
      const res = {
        summary_idx: {
          name: this.$t('table_head.hand'),
          sortKey: 'summary_idx',
          reverseSort: true,
          cssClass: 'gw_table_head_cell_sticky',
          cssStyle: '--min-width-th: 5rem;--max-width-th: 5rem',
          tdStyle: '--min-width-td: 5rem;--max-width-td: 5rem',
        },
        strategy: {
          name: this.$t('table_head.strategy'),
          sortKey: 'strategy',
          cssStyle: '--min-width-th: 8rem;--max-width-th: 8rem',
          tdStyle: '--min-width-td: 8rem;--max-width-td: 8rem',
        },
        range: {
          name: this.$t('table_head.range'),
          sortKey: 'range',
          ...styles,
        },
        ev: {
          name: this.getEvUnitHtml({ ...this.bettingInfo, player: '0' }),
          sortKey: 'ev',
          ...styles,
        },
        eq: {
          name: this.$t('table_head.eq_percent'),
          ...(this.showFlopContent ? { sortKey: 'eq' } : {}),
          ...styles,
        },
        eqr: {
          name: this.$t('table_head.eqr_percent'),
          ...(this.showFlopContent ? { sortKey: 'eqr' } : {}),
          ...styles,
        },
        ...(this.hasBlockers
          ? {
              blocker_rate: {
                name: this.$t('table_head.blocker_rate'),
                ...(this.showFlopContent && this.hasPremiumGameformat
                  ? { sortKey: 'blocker_rate' }
                  : {}),
                ...styles,
              },
            }
          : {}),
        ...(this.hasBlockers
          ? {
              unblocker_rate: {
                name: this.$t('table_head.unblocker_rate'),
                ...(this.showFlopContent && this.hasPremiumGameformat
                  ? { sortKey: 'unblocker_rate' }
                  : {}),
                ...styles,
              },
            }
          : {}),
      }
      return res
    },
  },
  watch: {
    thead: {
      immediate: true,
      handler: 'tbl_setSortConf',
    },
  },
}
</script>
